// extracted by mini-css-extract-plugin
module.exports = {"branding":"branding_branding__Qretz","brand_name":"branding_brand_name__BuTyS","logo":"branding_logo__W_153","highlight_ranking":"branding_highlight_ranking__TGZrY"};